import type { QueryKey, QueryObserverOptions } from "@tanstack/react-query"

import { minutes } from "@/3514/utils"

import type {
    TCoachDashboardParticipantsQueryKeyPayload as TParticipantsPayload,
    TCoachDashboardSessionsQueryKeyPayload as TSessionsPayload
} from "./coach.dashboard.api.types"

const ECacheTime: { MarkedAttendances(): Pick<QueryObserverOptions, "staleTime" | "gcTime"> } = {
    MarkedAttendances: (): Pick<QueryObserverOptions, "staleTime" | "gcTime"> => ({
        staleTime: minutes(30),
        gcTime: minutes(1)
    })
}

enum EQueryKeyBase {
    MarkedAttendances = "CoachDashboardMarkedAttendance",
    Sessions = "CoachDashboardSessions",
    Participants = "CoachDashboardParticipants"
}

const EQueryKey: {
    MarkedAttendances(): QueryKey
    Sessions(payload: TSessionsPayload): QueryKey
    Participants(payload: TParticipantsPayload): QueryKey
} = {
    MarkedAttendances: (): QueryKey => [EQueryKeyBase.MarkedAttendances],
    Sessions: (payload: TSessionsPayload): QueryKey => [
        EQueryKeyBase.Sessions,
        payload.search,
        payload.page,
        payload.period,
        payload.order
    ],
    Participants: (payload: TParticipantsPayload): QueryKey => [
        EQueryKeyBase.Participants,
        payload.search,
        payload.page
    ]
}

const EQueryUrl: {
    MarkedAttendances(): string
    Sessions(payload: TSessionsPayload): string
    Participants(payload: TParticipantsPayload): string
} = {
    MarkedAttendances: (): string => "/api/coach-session/without-attendance-marks/",
    Sessions: (payload: TSessionsPayload): string =>
        `/api/coach-session/?search=${payload.search}&page=${payload.page}&ordering=${payload.order}&session_period=${payload.period}`,
    Participants: (payload: TParticipantsPayload): string =>
        `/api/participants/?search=${payload.search}&page=${payload.page}`
}

export {
    ECacheTime as ECoachDashboardQueryCacheTime,
    EQueryKeyBase as ECoachDashboardQueryKeyBase,
    EQueryKey as ECoachDashboardQueryKey,
    EQueryUrl as ECoachDashboardQueryUrl
}
